<script lang="ts">
    import { ExclamationCircleOutline } from "flowbite-svelte-icons";
    import ColoredModal from "../colored/ColoredModal.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";

    let {isOpen = $bindable(), close}: { isOpen: boolean, close: () => void } = $props();

</script>

<ColoredModal autoclose bind:open={isOpen} onclose={close} size="xs">
    <div class="text-center">
        <ExclamationCircleOutline class="mx-auto mb-4 w-12 h-12"/>
        <h3 class="mb-5 text-lg font-normal">Do your DAR!</h3>
        <ColoredButton class="me-2">Okay</ColoredButton>
    </div>
</ColoredModal>
